import { render, staticRenderFns } from "./Backlog.vue?vue&type=template&id=bf8dc1ec&"
import script from "./Backlog.vue?vue&type=script&lang=js&"
export * from "./Backlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Backlog.vue"
export default component.exports